import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-dark text-white">
      <div className="container">
        <div className="row py-3">
          {/* Über uns */}
          <div className="col-md-3 col-sm-12">
            <h5 className="text-white">Über uns</h5>
            <p className="small">
              Grüne Wege GmbH - Ihr verlässlicher Partner im Garten- und
              Landschaftsbau. Wir gestalten Ihren Garten mit Leidenschaft.
            </p>
          </div>

          {/* Kontakt */}
          <div className="col-md-3 col-sm-12">
            <h5 className="text-white">Kontakt</h5>
            <ul className="list-unstyled small">
              <li>Telefon: +49 123 456 789</li>
              <li>Email: info@gruenewege.de</li>
              <li>Adresse: Musterstraße 123, 12345 Musterstadt</li>
            </ul>
          </div>

          {/* Wichtige Links */}
          <div className="col-md-3 col-sm-12">
            <h5 className="text-white">Wichtige Links</h5>
            <ul className="list-unstyled small">
              <li>
                <Link to="/impressum" className="text-white text-decoration-none">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/agb" className="text-white text-decoration-none">
                  AGB
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-white text-decoration-none">
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-3 col-sm-12">
            <h5 className="text-white">Folge uns</h5>
            <ul className="list-inline small">
              <li className="list-inline-item me-2">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <i className="bi bi-facebook fs-5"></i>
                </a>
              </li>
              <li className="list-inline-item me-2">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <i className="bi bi-instagram fs-5"></i>
                </a>
              </li>
              <li className="list-inline-item me-2">
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                >
                  <i className="bi bi-twitter fs-5"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="row border-top pt-2 mt-3">
          <div className="col text-center">
            <p className="small mb-0">
              &copy; {new Date().getFullYear()} Grüne Wege GmbH. Alle Rechte
              vorbehalten.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
